import { API } from '../config/api';
import { DataService } from '../config/dataService/dataService';

class CancellationReassonsService {
  static async getCancellationReassons({ page, search }) {
    const params = {
      page,
      search,
    };
    const { data } = await DataService.get(API.serviceCancellationReassons.root, params);
    return {
      cancellationReassons: data.cancellationReassons,
      total: data.total,
      pageSize: data.pageSize,
    };
  }

  static async getCancellationReassonById(notesId) {
    const { data } = await DataService.get(`${API.serviceCancellationReassons.root}/${notesId}`);
    return {
      cancellationReasson: data.cancellationReasson,
    };
  }

  static async createCancellationReasson(data) {
    const notesData = {
      name: data.name,
      description: data.description,
    };
    const { data: newData } = await DataService.post(API.serviceCancellationReassons.root, notesData);
    return {
      cancellationReasson: newData.cancellationReasson,
    };
  }

  static async updateCancellationReasson(id, newData) {
    const notesData = {
      name: newData.name,
      description: newData.description,
    };
    const { data } = await DataService.patch(`${API.serviceCancellationReassons.root}/${id}`, notesData);
    return {
      cancellationResson: data.cancellationResson,
    };
  }

  static async removeCancellationReasson(id) {
    const { data } = await DataService.delete(`${API.serviceCancellationReassons.root}/${id}`);
    return {
      cancellationReasson: data.cancellationReasson,
    };
  }
}

export { CancellationReassonsService };
